export default __webpack_public_path__ + "static/media/videoicon.9a57d9fd.svg";